import { isIDristi } from '../store/idbHandler';
import { GET_DRUGS_BY_IDS } from './constants';
import { Drug } from './fetchMatchingDrugsLabTests';
import fetchWithRefresh from './fetchWithRefresh';

export interface DrugsByIdsResponse {
    [id: string]: Drug;
}

export default (ids: string[]): Promise<DrugsByIdsResponse> => {
    if (isIDristi()) {
        return Promise.resolve({});
    }
    return fetchWithRefresh(GET_DRUGS_BY_IDS, {
        method: 'POST',
        body: JSON.stringify({ medicine_ids: ids }),
    }).then((res) => res.json());
};
